export const SECONDS_IN_MINUTE = 60;
export const MINUTES_IN_HOUR = 60;
export const HOURS_IN_DAY = 24;
export const MINUTES_IN_DAY = HOURS_IN_DAY * MINUTES_IN_HOUR;
// Calendar months vary in length - durations are approximated with a fixed 30-day month.
export const DAYS_IN_MONTH = 30;
export const MINUTES_IN_MONTH = DAYS_IN_MONTH * MINUTES_IN_DAY;
// JS Date timestamp lower bound (ECMA-262 §21.4.1.1)
export const MIN_REPRESENTABLE_DATE = -8.64e15;
